import { render, staticRenderFns } from "./emissionsProductDetail.vue?vue&type=template&id=356d9590"
import script from "./emissionsProductDetail.vue?vue&type=script&lang=js"
export * from "./emissionsProductDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('356d9590')) {
      api.createRecord('356d9590', component.options)
    } else {
      api.reload('356d9590', component.options)
    }
    module.hot.accept("./emissionsProductDetail.vue?vue&type=template&id=356d9590", function () {
      api.rerender('356d9590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/gas/emissionsProductDetail.vue"
export default component.exports